import React, { useEffect, useState } from 'react'
import { CButton, CCard, CCardBody, CCardFooter, CCardHeader, CCardTitle, CFormLabel, CFormSelect, CModal, CModalBody, CModalFooter, CTooltip, CAccordion, CAccordionItem, CAccordionHeader, CAccordionBody, CModalHeader, CModalTitle } from '@coreui/react'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import SaveQuestionProvider from '../../services/general/saveQuestionsProvider.api'
import DisplayNoteHpiQuestion from '../../components/shared/DisplayNoteHpiQuestion'
import SaveExtra from '../../services/general/saveExtraData.api'
import Graytextarea from '../../components/Graytextarea'
import { LetterTextIcon, Plus } from 'lucide-react'
import Select from 'react-select'
import { previousDay } from 'date-fns'
const HPIQuestions = ({ diagnosis, showDataIfNoteIsFollowUp, patientID = 908, noteID, isAllotedToProvider, patientDiagnosis, showTreatmentAsAccordion = false, patientTreatments = [] }) => {
  const [isPageLoading, setIsPatientPageLoading] = useState(false)
  const [diagnosisData, setDiagnosisData] = useState([])
  const [fetchedQuestions, setFetchedQuestions] = useState([])
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [subjective, setSubjective] = useState([])
  const [visible, setVisible] = useState(false)
  const [newFreeTypeText, setNewFreeTypeText] = useState('')

  const getData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    let options = []
    data.Data.map((obj) => {
      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })
    setDiagnosisData(options)
  }

  const GetFormDataForDiagnosis = async () => {
    let formattedData
    formattedData = await SaveQuestionProvider('GET', '', 'HPI', selectedDiagnosis?.value?.toString(), '')

    if (formattedData) {
      formattedData = JSON.parse(formattedData.d)?.Data || []
      formattedData = formattedData[0] || {}
      if (formattedData.questionData) {
        formattedData = {
          ...formattedData,
          questionData: JSON.parse(formattedData.questionData),
        }
      }
      setFetchedQuestions(formattedData)
    }
  }

  useEffect(() => {
    if (selectedDiagnosis) {
      GetFormDataForDiagnosis()
    }
  }, [selectedDiagnosis])

  useEffect(() => {
    getData()
  }, [])

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }

  const [patientFinalNoteHpi, setPatientFinalNoteHpi] = useState({})

  const fetchPatientFinalNoteDetails = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      let allData = JSON.parse(data?.d)

      const allPatientHpiData = allData?.Data?.map((item) => {
        return {
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })

      const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
      setSubjective(result[patientID])

      try {
        const hpiData = result?.[patientID]?.[noteID]?.HPI || {}
        const newFreeTypeTextFetched = result?.[patientID]?.[noteID]?.newFreeTypeText || ''
        if (newFreeTypeTextFetched) {
          setNewFreeTypeText(newFreeTypeTextFetched || '')
        }
        setPatientFinalNoteHpi(hpiData)
      } catch (error) {
        console.error('Error setting patient HPI:', error)
        setPatientFinalNoteHpi({})
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchPatientFinalNoteDetails()
  }, [])

  const getHpiQuestions = async () => {
    let diagnosisData = await GetDiagnosisData('')
    diagnosisData = JSON.parse(diagnosisData.d)?.Data

    const findDiagnosisId = diagnosisData?.find((item) => item.Name === diagnosisName)

    if (findDiagnosisId) {
      let data = await SaveQuestionProvider('GET', '', 'Incident', findDiagnosisId.id, '')
      data = JSON.parse(data?.d)?.Data || []

      //   const allParsedData = data.flatMap((item) => {
      //     try {
      //       const parsed = JSON.parse(item.questionData);
      //       return Array.isArray(parsed) ? parsed : [];
      //     } catch (err) {
      //       console.error("Invalid JSON in questionData:", item.questionData);
      //       return [];
      //     }
      //   });
    }
  }

  useEffect(() => {
    getHpiQuestions()
  }, [])

  const hpiNotes =
    (diagnosis || [])
      .map((diagnosisItem) => {
        const hpiData = patientFinalNoteHpi?.[diagnosisItem] || []

        let freeTypeRemark = ''
        if (hpiData.length > 0 && hpiData[0]?.freewayRemark) {
          freeTypeRemark = `<div style="padding-left: 10px; color: #444; white-space: normal; ">
      Global Freetype: ${hpiData[0]?.freewayRemark}
    </div>`
        }

        const formattedHpi =
          hpiData.length > 0
            ? hpiData
                .map((hpi) => {
                  const label = hpi?.label || ''
                  const answer = Array.isArray(hpi?.answer) ? hpi.answer.join(', ') : hpi?.answer || ''
                  const freeType = hpi?.freeType || ''
                  const parentQuestion = hpi?.parentQuestion?.split('-')[1] || ''
                  return `<div style="padding-left: 10px;">

  <span>
    ${parentQuestion !== '' ? `[${parentQuestion}]` : ''} ${label}: ${answer}
    ${freeType ? `<br/> Freetype: ${freeType}` : ''}
  </span>
</div>`
                })
                .join('')
            : ''

        return formattedHpi
          ? `
            <div style="margin-bottom: 10px;">
              <p style="margin: 0; font-weight: 700; line-height: normal; font-size: 11pt;">
                ${diagnosisItem?.toUpperCase()}
              </p>
                ${freeTypeRemark}
              <div>${formattedHpi}</div>
            </div>
          `
          : ''
      })
      .join('') || ''

  const [questionsWithDiagnosis, setQuestionsWithDiagnosis] = useState({})

  const getQuestionForDiagnosis = async () => {
    let diagnosisData = await GetDiagnosisData('')
    diagnosisData = JSON.parse(diagnosisData.d)?.Data

    const findDiagnosisIids = diagnosisData?.filter((item) => patientDiagnosis?.includes(item?.Name))

    const structured = {}

    if (findDiagnosisIids?.length > 0) {
      await Promise.all(
        findDiagnosisIids.map(async (diagnos) => {
          let data = await SaveQuestionProvider('GET', '', 'HPI', diagnos.id, '')
          data = JSON.parse(data?.d)?.Data || []

          // Extract questionData arrays, parse each, and flatten into one array
          const questions = data
            .map((q) => {
              try {
                return JSON.parse(q.questionData)
              } catch (e) {
                return [] // fallback if parse fails
              }
            })
            .flat() // flatten to one array

          structured[diagnos.Name] = questions
        }),
      )
    }

    setQuestionsWithDiagnosis(structured)
  }

  useEffect(() => {
    getQuestionForDiagnosis()
  }, [patientID])

  const handleSubmit = async () => {
    if (noteID === 0) {
      const finalHpiStructure = {
        [patientID]: {
          [noteID]: {
            HPI: Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
              acc[key] = questions.map(({ answer, freetype, label, parentQuestion }) => ({
                answer,
                freetype,
                label,
                parentQuestion,
              }))
              return acc
            }, {}),
            medicationRemarksForSubjective: '',
            data: '',
          },
        },
      }
      let data = await SaveExtra('INSERT', 'PatientHPI', JSON.stringify(finalHpiStructure), '')
      setVisible(false)
      setQuestionsWithDiagnosis({})
      fetchPatientFinalNoteDetails()
    } else {
      let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      let allData = JSON.parse(data?.d)
      const allPatientHpiData = allData?.Data?.map((item) => {
        return {
          Id: item?.Id,
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })
      if (patientID && Number(noteID)) {
        const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
        const latestPatientHPISecondTimeNoteWithSubjective = result[patientID]
        const finalHpiStructure = {
          [patientID]: {
            [noteID]: {
              HPI: Object.entries(questionsWithDiagnosis).reduce((acc, [key, questions]) => {
                acc[key] = questions.map(({ answer, freetype, label, parentQuestion }) => ({
                  answer,
                  freetype,
                  label,
                  parentQuestion,
                }))
                return acc
              }, {}),
              medicationRemarksForSubjective: latestPatientHPISecondTimeNoteWithSubjective[noteID]?.medicationRemarksForSubjective || '',
              data: latestPatientHPISecondTimeNoteWithSubjective[noteID]?.data || '',
            },
          },
        }
        await SaveExtra('UPDATE', 'PatientHPI', JSON.stringify(finalHpiStructure), result?.Id)
        setVisible(false)
        fetchPatientFinalNoteDetails()
      }
    }
  }

  return (
    <>
      {showTreatmentAsAccordion ? (
        <div className="d-flex  flex-column gap-2 ">
          <div className="d-flex align-items-center gap-2">
            <p className="mb-0" style={{ fontSize: '16px' }}>
              {patientTreatments?.length > 1 ? 'Subjective' : 'HPI'}
            </p>
          </div>

          <div className="px-4">
            {patientTreatments?.length > 1 && subjective[noteID]?.medicationRemarksForSubjective && (
              <div>
                <div
                  className="   "
                  style={{
                    overflowY: 'auto',
                    whiteSpace: 'pre-wrap',
                    fontSize: '1rem',
                  }}
                >
                  {subjective[noteID]?.medicationRemarksForSubjective}
                </div>
              </div>
            )}

            <div>
              <div
                style={{
                  borderRadius: '10px',
                  // marginTop: '10px',
                  fontSize: '16px',
                  fontFamily: 'Plus Jakarta Sans',
                  color: '#2c384af2',
                }}
                dangerouslySetInnerHTML={{
                  __html: hpiNotes,
                }}
              />
            </div>

            {patientTreatments?.length > 1 && subjective[noteID]?.data && (
              <div>
                <div
                  style={{
                    borderRadius: '10px',

                    fontSize: '16px',
                    fontFamily: 'Plus Jakarta Sans',
                    color: '#2c384af2',

                    backgroundColor: showTreatmentAsAccordion ? '' : '#8080800d',
                    whiteSpace: 'pre-wrap', // preserves line breaks
                  }}
                >
                  {subjective[noteID]?.data || '—'}
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="d-flex  flex-column gap-2 ">
          <div className="d-flex align-items-center gap-2">
            <h6 className="fs-7 text-primary" style={{ color: '#808080', opacity: '0.8' }}>
              {showDataIfNoteIsFollowUp ? 'Subjective' : 'HPI'}
            </h6>
            {isAllotedToProvider && (
              <CFormLabel
                className="d-flex mt flex-column align-items-center justify-content-center shadow "
                onClick={() => setVisible((p) => !p)}
                style={{
                  width: '30px',
                  height: '30px',
                  borderRadius: '20px',
                  background: 'var(--ui-color-primary, #2b7cd3)',
                  cursor: 'pointer',
                }}
              >
                <Plus className="text-white" strokeWidth={2} size={15} />
              </CFormLabel>
            )}
          </div>
          {showDataIfNoteIsFollowUp && subjective[noteID]?.medicationRemarksForSubjective && (
            <div>
              <Graytextarea value={subjective[noteID]?.medicationRemarksForSubjective} height={'100px'} />
            </div>
          )}

          {/* <div>
                <CAccordion flush className="mt-2">
                    {diagnosis?.map((item, index) => (
                        item !== "" && item !== undefined && (
                            <CAccordionItem key={index} itemKey={index} onClick={() => { handleSelectAccordian(item) }}>
                                <CAccordionHeader>{item}</CAccordionHeader>
                                {fetchedQuestions.questionData && (
                                    <CAccordionBody>
                                        <div className="bg-white d-flex flex-column gap-4">
                                            <DisplayNoteHpiQuestion fetchedQuestions={fetchedQuestions} />
                                        </div>
                                    </CAccordionBody>
                                )}
                            </CAccordionItem>
                        )
                    ))}
                </CAccordion>

               </div> */}
          <div>
            {newFreeTypeText && <p style={{ whiteSpace: 'pre-wrap' }}>{newFreeTypeText || ''}</p>}
            <div
              style={{
                // preserve line breaks and spaces
                // border: '1px solid #ccc',
                borderRadius: '10px',
                padding: '8px',
                fontSize: '16px',
                fontFamily: 'Plus Jakarta Sans',
                color: '#2c384af2',
                minHeight: hpiNotes ? '120px' : '40px',
                // overflowY: 'auto',

                backgroundColor: '#8080800d',
              }}
              dangerouslySetInnerHTML={{ __html: hpiNotes }}
            />
          </div>

          <Graytextarea value={subjective[noteID]?.data} height={'20px'} />
          {/* {showDataIfNoteIsFollowUp && subjective[noteID]?.data && <div>
                </div>} */}
        </div>
      )}

      <CModal className="incident-modal" centered visible={visible} size="lg" alignment="center" onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">Add HPI Questions</CModalTitle>
        </CModalHeader>
        <CModalBody className="d-flex flex-column gap-2 h-75">
          {Object.entries(questionsWithDiagnosis).map(([key, value], index) => {
            return (
              <CAccordion key={index} alwaysOpen activeItemKey={index === 0 ? 1 : null}>
                <CAccordionItem itemKey={1}>
                  <CAccordionHeader>{key}</CAccordionHeader>
                  <CAccordionBody>
                    {value.map((item, idx) => {
                      return (
                        <div key={item.id} className="mb-3">
                          <div className="d-flex items-center gap-1">
                            <p>{idx + 1}.</p>
                            <CFormLabel>{item.label}</CFormLabel>
                          </div>

                          {item.type === 'dropdown' && (
                            <Select
                              onChange={(e) => {
                                setQuestionsWithDiagnosis((prevData) => {
                                  const newData = { ...prevData }
                                  newData[key][idx].answer = e.value
                                  return newData
                                })
                              }}
                              value={item.answer ? { value: item.answer, label: item.answer } : null}
                              options={
                                item.options?.map((opt) => ({
                                  value: opt.label || opt.label,
                                  label: opt.label,
                                })) || []
                              }
                              placeholder="Select an option"
                            />
                          )}

                          <span className="d-block pt-2">
                            <Graytextarea
                              value={item.freeType}
                              onChange={(e) => {
                                setQuestionsWithDiagnosis((prevData) => {
                                  const newData = { ...prevData }
                                  newData[key][idx].freeType = e.target.value
                                  return newData
                                })
                              }}
                              height={'100px'}
                              placeholder={'Freetype'}
                            />
                          </span>
                        </div>
                      )
                    })}
                  </CAccordionBody>
                </CAccordionItem>
              </CAccordion>
            )
          })}
        </CModalBody>
        <CModalFooter>
          <CButton onClick={() => setVisible(false)} color="secondary">
            Close
          </CButton>
          <CButton onClick={handleSubmit}>Save</CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default HPIQuestions
